// Stable per-device child identifier.
//
// Used by the Question Bank + rotation logic on the backend to keep
// per-child history without any authenticated identity. Generated
// once, cached in localStorage. Purely a random uuid — no personal
// data, so the app stays account-less and COPPA-compatible.
const KEY = "we_child_id_v1";

function _uuid() {
  // Not RFC-strict but sufficient for a per-device tag.
  const rand = () => Math.random().toString(16).slice(2, 10);
  return `child_${rand()}${rand()}`;
}

const DEVICE_KEY = "mwq_device_key_v1";

/** Second device-local random secret, sent ONLY as the `X-Device-Key` header (never in a URL) to prove a
 *  learner-scoped request comes from the device that owns the learner id. */
export function getDeviceKey() {
  try {
    let k = localStorage.getItem(DEVICE_KEY);
    if (!k) { k = `dk_${_uuid().slice(6)}${_uuid().slice(6)}`; localStorage.setItem(DEVICE_KEY, k); }
    return k;
  } catch { return ""; }
}

/** Headers for learner-scoped API calls. */
export const learnerHeaders = (extra = {}) => ({ "Content-Type": "application/json", "X-Device-Key": getDeviceKey(), ...extra });

export function getChildId() {
  try {
    let id = localStorage.getItem(KEY);
    if (!id) {
      id = _uuid();
      localStorage.setItem(KEY, id);
    }
    return id;
  } catch {
    // Storage blocked (e.g. Safari Private Mode) → return a session-only
    // id so requests still work; rotation just won't persist across
    // reloads for this session, which is acceptable.
    return _uuid();
  }
}
